module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.iterators.js
 ** module id = 24
 ** module chunks = 2
 **/